import { Layout } from "@Components/Layout";
import dynamic from "next/dynamic";
import Head from "next/head";
const AboutUsPage = dynamic(() => import("@Components/Pages/About-us"), {
  ssr: false,
});

const AboutUs = () => {
  return (
    <>
      <Head>
        <title>About us - Econut</title>
        <meta
          name="description"
          content="At Econut, explore the variety of cold-pressed oils, organic shampoo and hair gel.
          Check out our Coconut, Groundnut Organic Oil and pure Baby Coconut Oil. Chemical-free, natural
          goodness from us is only a click away. Begin the journey with us by knowing who we are and what
          we stand for!"
        />
        <meta
          name="title"
          content="Econut | Act Conscious | Organic &amp; Cold Pressed"
        />
        <meta
          name="keywords"
          content="Virgin Oil,Extra virgin coconut oil,Coconut Oil,Coconut products,Organic coconut oil, Natural,Coconut Oil,India,Nutrition,Weight,Weight-loss,Nutritional,Cold-pressed,Cold-pressed products,Body,Health,Wellness,Wellbeing,Pure,Premium,Exclusive,Consumer products,Cardiometabolic health,Copra oil,Lauric acid Medium-chain triglycerides,Eco-friendly products,Sustainable products,Natural Products, 100%Natural,100%Organic,100%pure,Made in India,Make in India"
        />
      </Head>
      <Layout>
        <AboutUsPage />
      </Layout>
    </>
  );
};
export default AboutUs;
// AboutUs.displayName = "login";
